import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import RoomGroupService from "../../services/roomgroup.service";
import AuthService from "../../services/auth.service";



export const addroomgroup = createAsyncThunk(
    "roomgroup/post/roomGroup",
    async(item, thunkAPI) => {
        try {
            const data = await RoomGroupService.postroomgroup(item);
            return { user: data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);


// export const logout = createAsyncThunk("auth/logout", async () => {
//   AuthService.logout();
// });

const initialState = {
    loading: false,
    error: "",
    user: AuthService.getUserDetails() || null,
    isLoggedIn: false,
};

const roomGroupSlice = createSlice({
    name: "roomGroup",
    initialState,
    extraReducers: {
       
        [addroomgroup.pending]: (state) => {
            state.loading = true;
            state.error = "";
            state.isLoggedIn = false;
            state.user = null;
        },
        [addroomgroup.fulfilled]: (state, action) => {
            state.loading = false;
            state.error = "";
            state.isLoggedIn = true;
            state.user = action.payload.user;
        },
        [addroomgroup.rejected]: (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
            state.isLoggedIn = false;
            state.user = null;
        },
        // [logout.fulfilled]: (state, action) => {
        //   state.isLoggedIn = false;
        //   state.user = null;
        // },
    },
});

const { reducer } = roomGroupSlice;
export default reducer;